import { Component, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../../utils/Loader";

import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, adjustAreaId, adjustAreaFromToId } from "../../../../utils/constants";
import { getAreaManagementList_action, updateAreaManagement_action } from '../../../../actions/admin_module_action/manage_area/area_management_action/area_management_action';
import Pagination from "../../../../utils/pagination";
import { fill_action } from '../../../../actions/fillCombo_action';
import moment from 'moment';
class AreaManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            areaManagementList: [],
            Area: '',
            AreaErr: '',
            FromErr: '',
            ToErr: '',
            adjustAreaErr: '',
            AdjustAreaId: '',
            fromId: '',
            toId: '',
            adjustAreaList: [],
            adjustAreaFromToList: [],
            Buffer: 0,
            TotalArea: 0,
            Available: 0,
            bufferErr: '',
            availableErr: ''
        }

        this.updateItem = this.updateItem.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.getFillList(adjustAreaId, '', '', '', '', '');
        this.getFillList(adjustAreaFromToId, '', '', '', '', '');

        this.getAreaManagementList()

    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === adjustAreaId) {
                        // console.log("exhibitorList", data.data)
                        this.setState({
                            adjustAreaList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === adjustAreaFromToId) {
                        // console.log("accountTypeList", data.data)
                        this.setState({
                            adjustAreaFromToList: data.data, isLoading: false,
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }


    getAreaManagementList() {
        const { AdjustAreaId } = this.state
        this.setState({ isLoading: true })
        this.props.getAreaManagementList_action(
            AdjustAreaId != '' && AdjustAreaId != 'Select' ? AdjustAreaId : null
        )
            .then((data) => {
                if (data.error != 1) {
                    console.log("data", data)

                    if (data.data != '') {
                        if (data.data[0]['emptyData'] != 'empty') {
                            this.setState({
                                isLoading: false,
                                areaManagementList: data.data
                            })
                        } else {
                            this.setState({
                                isLoading: false,
                                areaManagementList: []
                            })
                        }
                    } else {
                        this.setState({
                            isLoading: false,
                            areaManagementList: data.data
                        })
                    }

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    updateAreaManagement() {
        const { AdjustAreaId, fromId, toId, Area, adjustAreaList, Buffer, TotalArea, Available } = this.state

        if (fromId == 'Buffer') {
            if (Buffer >= parseInt(Area)) {
                var buffCondition = true
            } else {
                var buffCondition = false
                this.setState({ bufferErr: 'adjust are can not be more than Buffer area' })
            }
        } else {
            if (Available >= parseInt(Area)) {
                var availableCondition = true
            } else {
                var availableCondition = false
                this.setState({ availableErr: 'adjust are can not be more than available area' })
            }
        }

        this.setState({ isLoading: true })
        this.props.updateAreaManagement_action(AdjustAreaId, fromId, toId, Area)
            .then((data) => {
                if (data.error != 1) {

                    toastSuccess("Area manage successfully")

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    handleClear() {
        const { areaManagementList } = this.state

        this.setState({
            Area: '',
            AreaErr: '',
            FromErr: '',
            ToErr: '',
            adjustAreaErr: '',
            AdjustAreaId: '',
            fromId: '',
            toId: '',
            Buffer: 0,
            TotalArea: 0,
            Available: 0,
            bufferErr: '',
            availableErr: ''
        })
        setTimeout(() => {
            this.getAreaManagementList()
            this.getFillList(adjustAreaId, '', '', '', '', '');
        }, 100);
    }

    inputValidate() {
        const { AdjustAreaId, fromId, toId, Area } = this.state
        if (AdjustAreaId == "" || AdjustAreaId == null || AdjustAreaId == 'Select') {
            this.setState({ adjustAreaErr: 'Please select adjust area' })
        }
        if (fromId == "" || fromId == null || fromId == 'Select') {
            this.setState({ FromErr: 'Please select from area' })
        }
        if (toId == "" || toId == null || toId == 'Select') {
            this.setState({ ToErr: 'Please select to area' })
        }
        if (Area == "" || Area == null) {
            this.setState({ AreaErr: 'Please enter area' })
        }

    }

    adjustArea() {
        const { AdjustAreaId, fromId, toId, Area, adjustAreaList, Buffer, TotalArea, Available, AreaErr } = this.state
        this.inputValidate()
        console.log("Buffer ------------------", Buffer)
        console.log("Available ------------------", Available)
        setTimeout(() => {
            var buffCondition = false
            var availableCondition = false
            if (Area != '') {
                if (fromId == 'Buffer') {
                    if (Buffer >= parseInt(Area)) {
                        var buffCondition = true
                        this.setState({ bufferErr: '' })
                        this.setState({ availableErr: '' })
                    } else {
                        var buffCondition = false
                        this.setState({ bufferErr: 'Enter Area can not be more than Buffer area' })
                        this.setState({ availableErr: '' })
                    }
                } else if (fromId == 'Available') {
                    if (Available >= parseInt(Area)) {
                        var availableCondition = true
                        this.setState({ bufferErr: '' })
                        this.setState({ availableErr: '' })
                    } else {
                        var availableCondition = false
                        this.setState({ availableErr: 'Enter Area can not be more than available area' })
                        this.setState({ bufferErr: '' })
                    }
                }
            }

            adjustAreaList != '' ?
                adjustAreaList.map((data) => {
                    if (data.ChapterID == AdjustAreaId) {
                        console.log("step ------------------",)
                        const primaryChapterId = data.ChapterID
                        this.setState({ isLoading: true })
                        if (AdjustAreaId != '' && fromId != '' && fromId != 'Select' && toId != '' && toId != 'Select' && Area != '') {
                            if (buffCondition == true || availableCondition == true) {
                                this.props.updateAreaManagement_action(primaryChapterId, fromId, toId, Area)
                                    .then((data) => {
                                        if (data.error != 1) {
                                            this.setState({ isLoading: false })
                                            toastSuccess("Area manage successfully")
                                            this.getAreaManagementList()
                                            this.handleClear()
                                        } else {
                                            this.setState({ isLoading: false })
                                            toastError(data.msg)
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err)
                                    })
                            } else {
                                this.setState({ isLoading: false })
                            }
                        } else {
                            this.setState({ isLoading: false })
                        }
                    }
                }) : <></>
        }, 100);

    }

    onAdjustAreaFill(e) {

        const { adjustAreaList } = this.state


        if (e.target.value != '' && e.target.value != 'Select') {
            adjustAreaList.map((data) => {
                if (data.ChapterID == e.target.value) {
                    this.setState({
                        Buffer: data.Buffer,
                        TotalArea: data.TotalArea,
                        Available: data.Available,
                    })
                }
            })
            this.setState({ AdjustAreaId: e.target.value, adjustAreaErr: '' })
        } else {
            this.setState({
                Buffer: 0,
                TotalArea: 0,
                Available: 0,
            })
            this.setState({ AdjustAreaId: '', adjustAreaErr: '' })
        }
        setTimeout(() => {
            this.getAreaManagementList()
        }, 100);
    }

    updateItem(item) {
        const { areaManagementList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = areaManagementList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(areaManagementList.length / recordsPerPage)
    }

    manageAreaInput(e) {

        if (e.target.value.replace(/\D/, '') != '') {
            this.setState({ Area: e.target.value.replace(/\D/, ''), AreaErr: '', bufferErr: '', availableErr: '' })
        } else {
            this.setState({
                Area: ''
            })
        }
    }

    render() {
        const { isLoading, areaManagementList, AdjustAreaId, Area, currentPage, AreaErr, FromErr, ToErr, adjustAreaErr, toId, fromId, adjustAreaList, adjustAreaFromToList, Buffer, TotalArea, Available, bufferErr, availableErr } = this.state

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = areaManagementList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(areaManagementList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />

                    <div className="main-content">

  {/* ===== Adjust Area Card ===== */}
  <div className="card mb-3">
    <div className="card-body">

      {/* Row 1 */}
      <div className="row align-items-end g-3">

        <div className="col-12 col-md-3">
          <label className="">Adjust Area</label>
          <select
            className="form-control"
            value={AdjustAreaId}
            onChange={(e) => this.onAdjustAreaFill(e)}
          >
            <option value="">Select</option>
            {adjustAreaList.map((data) => (
              <option key={data.ChapterID} value={data.ChapterID}>
                {data.PrimaryChapter}
              </option>
            ))}
          </select>
          {adjustAreaErr && <small className="text-danger areacontrol-error">{adjustAreaErr}</small>}
        </div>

        <div className="col-12 col-md-4">
  <div className="d-flex border rounded overflow-hidden p-0">

    <div className="flex-fill p-2 text-center border-end">
      <strong>Available Area</strong><br />
      {Available} m<sup>2</sup>
    </div>

    <div className="flex-fill p-2 text-center">
      <strong>Buffer Area</strong><br />
      {Buffer} m<sup>2</sup>
    </div>

  </div>
</div>


      </div>

      {/* Row 2 */}
      <div className="row align-items-end g-3 mt-1">

        <div className="col-12 col-md-3">
          <label className="">From</label>
          <select
            className="form-control"
            value={fromId}
            onChange={(e) => this.setState({ fromId: e.target.value, FromErr: '' })}
          >
            <option value="">Select</option>
            {adjustAreaFromToList.map((data) => (
              <option key={data.CODE} value={data.CODE}>{data.NAME}</option>
            ))}
          </select>
          {FromErr && <small className="text-danger areacontrol-error">{FromErr}</small>}
        </div>

        <div className="col-12 col-md-3">
          <label className="">To</label>
          <select
            className="form-control"
            value={toId}
            onChange={(e) => this.setState({ toId: e.target.value, ToErr: '' })}
          >
            <option value="">Select</option>
            {adjustAreaFromToList.map((data) => (
              <option key={data.CODE} value={data.CODE}>{data.NAME}</option>
            ))}
          </select>
          {ToErr && <small className="text-danger areacontrol-error">{ToErr}</small>}
        </div>

        <div className="col-12 col-md-4">
          <label className="">Area</label>
          <input
            type="text"
            className="form-control"
            value={Area}
            maxLength={30}
            onChange={(e) => this.manageAreaInput(e)}
          />
          {AreaErr && <small className="text-danger areacontrol-error">{AreaErr}</small>}
          {bufferErr && <small className="text-danger areacontrol-error">{bufferErr}</small>}
          {availableErr && <small className="text-danger areacontrol-error">{availableErr}</small>}
        </div>

        <div className="col-12 col-md-2 text-md-end">
          <button
            className="btn btn-aqua w-100"
            onClick={() => this.adjustArea()}
          >
            Adjust Area
          </button>
        </div>

      </div>

    </div>
  </div>

  {/* ===== Table ===== */}
  <div className="card">
    <div className="card-body table-responsive">

      <table className="table table-bordered align-middle">
        <thead className="table-light">
          <tr>
            <th>User Name</th>
            <th>Date</th>
            <th>Chapter</th>
            <th>From</th>
            <th>To</th>
            <th>Area</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords && currentRecords.length > 0 ? (
            currentRecords.map((data, i) => (
              <tr key={i}>
                <td>{data.UserName}</td>
                <td>{data.CreatedDate ? moment(data.CreatedDate).format('DD-MM-YYYY') : '-'}</td>
                <td>{data.ChapterName || '-'}</td>
                <td>{data.FromID}</td>
                <td>{data.ToID}</td>
                <td>{data.Area || '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center text-muted">
                Record not found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="d-flex justify-content-between align-items-center mt-2">
        {areaManagementList.length > 0 && (
          <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={this.updateItem}
          />
        )}
        <span className="text-muted">
          {`${currentPage} of ${nPages} pages`}
        </span>
      </div>

    </div>
  </div>

</div>


                </>

                {/* <Footerwithdr /> */}

            </>
        );
    }


}

export default withRouter(connect(null, { getAreaManagementList_action, updateAreaManagement_action, fill_action })(AreaManagement));